export const EmptyUser = {
    login_ID: undefined,
    user_Name: '',
    login_Name: '',
    user_EmailID: '',
    user_Status: false,
    temp_Inactive: false,
    login_Password: '',
    experience_In_Month:null,
}